import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ReportContext, ReportDefinition } from '../../../report.models';
import { RouteAnalysisTableComponent } from '../route-analysis-report/route-analysis-table.component';
import { OriginDestinationSummaryReportApiService } from './origin-destination-summary-report-api.service';
import { OriginDestinationSummaryRow } from './origin-destination-summary-report.models';
import { ORIGIN_DESTINATION_SUMMARY_COLUMNS } from './origin-destination-summary-report.utils';

@Component({ selector: 'app-origin-destination-summary-report', templateUrl: './origin-destination-summary-report.component.html' })
export class OriginDestinationSummaryReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: OriginDestinationSummaryRow[] = [];
  readonly columns = ORIGIN_DESTINATION_SUMMARY_COLUMNS;
  loading = false;
  hasError = false;
  errorMessage = '';
  private version = 0;
  private destroyed = false;
  constructor(private readonly api: OriginDestinationSummaryReportApiService, private readonly guard: GurdServiceService,
    private readonly notify: NotificationService, private readonly other: OtherService, private readonly router: Router, private readonly location: Location) {}
  get subtitle(): string { return `از تاریخ ${this.context.startDate} الی ${this.context.endDate}`; }
  get tableKey(): string { return `origin-destination-summary-${this.context.id}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.version; this.loading = false; this.rows = []; this.table?.reset(); void this.loadReport();
  }
  ngOnDestroy(): void { this.destroyed = true; ++this.version; }
  goBack(): void { this.location.back(); }
  async loadReport(): Promise<void> {
    if (this.loading || this.destroyed) return;
    const version = ++this.version; this.loading = true; this.hasError = false; this.errorMessage = '';
    try {
      const result = await this.api.load({ strSDate: this.context.startDate, strEDate: this.context.endDate,
        iSystemUser: this.guard.decrypt(localStorage.getItem('ID')!), strSession: this.guard.decrypt(localStorage.getItem('Session')!) });
      if (version !== this.version) return;
      if (!Array.isArray(result)) {
        if (result.ISSessionExpired || result.ISessionExpired) {
          this.notify.showError('لطفا وارد سیستم شوید'); this.other.removeLocalStorage();
          void this.router.navigate(['login'], { queryParams: { report: 'source-dest' } }); return;
        }
        throw new Error(result.strError || 'دریافت اطلاعات با خطا مواجه شد');
      }
      this.rows = result.map(row => ({ ...row, displayPlate: row.strVehicleNo ? this.other.returnCorrectPlate(row.strVehicleNo) : '' }));
    } catch (error) {
      if (version !== this.version) return;
      this.rows = []; this.hasError = true; this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
    } finally { if (version === this.version) this.loading = false; }
  }
}
